export default __webpack_public_path__ + "static/media/Barefeet-5.89ffd45b.webp";